import React from 'react';
import { Ring } from 'ldrs/react';
import 'ldrs/react/Ring.css';

const Loader = () => {
  return (
   <Ring
    size="40"
    stroke="5"
    bg-opacity="0"
    speed="0.8"
    color="black" />
  );
};

export default Loader;
